import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="w-full">
      <div *ngIf="showLabel" class="flex justify-between items-center mb-2">
        <span class="text-sm font-medium text-gray-700">{{ label }}</span>
        <span class="text-sm font-semibold text-blue-600">{{ value }}%</span>
      </div>
      <div [class]="'w-full bg-gray-200 rounded-full overflow-hidden ' + heightClass">
        <div
          class="h-full bg-blue-600 rounded-full transition-all duration-300 ease-in-out"
          [style.width.%]="value"
          [class]="colorClass"
        ></div>
      </div>
    </div>
  `
})
export class ProgressBarComponent {
  @Input() value: number = 0;
  @Input() label: string = '';
  @Input() showLabel: boolean = true;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() color: 'blue' | 'green' | 'amber' | 'red' = 'blue';

  get heightClass(): string {
    const heights = {
      sm: 'h-1',
      md: 'h-2.5',
      lg: 'h-4'
    };
    return heights[this.size];
  }

  get colorClass(): string {
    const colors = {
      blue: 'bg-blue-600',
      green: 'bg-emerald-600',
      amber: 'bg-amber-500',
      red: 'bg-red-600'
    };
    return colors[this.color];
  }
}
